import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { Button } from "@/shared/components/ui/Button";
import { Logo } from "@/shared/components/ui/Logo";
import { FormField } from "@/shared/components/form/FormField";
import { useRequestPasswordReset } from "@/shared/lib/auth";

export function PasswordRecover() {
  const recover = useRequestPasswordReset();
  const [email, setEmail] = useState("");

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    recover.mutate({ email });
  }

  return (
    <Section
      spacing="lg"
      className="min-h-screen flex flex-col items-center justify-center gap-8"
    >
      <Logo to="/" />
      <Container size="sm">
        <div className="glass-surface-strong rounded-2xl p-8 flex flex-col gap-6">
          {recover.isSuccess ? (
            <>
              <div className="flex flex-col gap-2 text-center">
                <h1 className="type-heading-md text-text">Check your email</h1>
                <p className="type-body-base text-text-muted">
                  If an account exists for that address, we&apos;ve sent a link to reset your
                  password. The link expires in one hour.
                </p>
              </div>
              <p className="type-body-sm text-text-muted text-center">
                <Link to="/auth/login" className="text-brand underline-offset-4 hover:underline">
                  Back to sign in
                </Link>
              </p>
            </>
          ) : (
            <>
              <div className="flex flex-col gap-2 text-center">
                <h1 className="type-heading-md text-text">Recover your account</h1>
                <p className="type-body-base text-text-muted">
                  Enter your email and we&apos;ll send you a link to reset your password.
                </p>
              </div>
              <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
                <FormField
                  label="Email"
                  type="email"
                  name="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {recover.error ? (
                  <p className="type-body-sm text-danger-strong mx-4">
                    {recover.error.message}
                  </p>
                ) : null}
                <Button type="submit" disabled={recover.isPending}>
                  {recover.isPending ? "Sending…" : "Send reset link"}
                </Button>
              </form>
              <p className="type-body-sm text-text-muted text-center">
                Remembered it?{" "}
                <Link to="/auth/login" className="text-brand underline-offset-4 hover:underline">
                  Sign in
                </Link>
              </p>
            </>
          )}
        </div>
      </Container>
    </Section>
  );
}
